import Vue from 'vue'
import Router from 'vue-router'

// Containers
const AuthContainer = () => import('@/containers/AuthContainer')

// Views
const Login = () => import('@/views/Login')
const ForgotPassword = () => import('@/views/ForgotPassword')
const ResetPassword = () => import('@/views/ResetPassword')
const ChangePassword = () => import('@/views/ChangePassword')
const Registration = () => import('@/views/Registration')

const Page404 = () => import('@/views/Page404')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/login',
      name: '',
      component: AuthContainer,
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          props: (route) => ({ query: route.query.appId }),
          meta: {
            appIdRequired: true
          }
        },
        {
          path: 'forgot-password',
          name: 'Forgot Password',
          component: ForgotPassword,
          props: (route) => ({ query: route.query.appId }),
        },
        {
          path: 'reset-password',
          name: 'Reset Password',
          component: ResetPassword,
          props: (route) => ({ query: route.query.hash }, { query: route.query.user }),
        },
        {
          path: 'change-password',
          name: 'Change Password',
          component: ChangePassword,
          props: (route) => ({ query: route.query.hash }, { query: route.query.appId }, {query: route.query.changeInitRegPass}),
        },
        {
          path: 'registration',
          name: 'Registration',
          component: Registration,
          props: (route) => ({ query: route.query.appId }),
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        }
      ]
    }
  ]
})

// navigation guards
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.appIdRequired)) {
    if (!to.query.appId) {
      next({path: '/pages/404'})
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
